export default {
  gameDifficulty: {
    easy: '簡単',
    medium: '中程度',
    hard: '難しい',
  },
  editButton: '編集',
  imgEditDialog: '編集',
  imgUploadDialog: 'アップロード',
  downloadModel: 'スケルトンモデルをダウンロード',
  uploadCover: 'カバーをアップロード',
  difficultyV1: {
    warningText1: '入力された数字が上限を超えています',
    warningText2: '入力された数字が上限を超えています',
    warningText3: '有効な数字を入力してください',
  },
  difficultyV2: {
    alertText:
      'データ形式が正しくありません。数字、配列、または文字列を使用してください',
  },
  difficultyV3: {
    alertText: '設定データ形式エラー。お問い合わせください',
    alertDesc: {
      config: '設定：',
      error: '詳細なエラー：',
    },
    inputTips: '1〜50文字のみ入力可能です',
    inputItem: {
      required: 'テキストボックスは空にできません',
      placeholder: '1〜50文字のみ入力可能です',
    },
    inputNumberTips: '数字のみ入力可能です',
    inputNumberItem: {
      required: 'テキストボックスは空にできません',
      placeholder: '数字のみ入力可能です',
    },
    checkboxItem: {
      required: 'オプションは空にできません',
    },
    unKnowText: '未知のタイプ、設定を確認してください',
  },
  difficultySlider: {
    rangeText: 'ドラッグエリアの調整',
    submit: '確定',
    cancle: 'キャンセル',
    title: '調整',
    form: {
      min: {
        required: '最小値は空にできません',
        label: '最小値',
        warningLable: '数値',
        warningText1: '有効な整数を入力してください',
        warningText2: '入力された数字が上限を超えています',
        warningText3: '最小制限を下回る数字が入力されました',
        warningText4: '最小値は最大値以上にできません',
      },
      max: {
        required: '最大値は空にできません',
        label: '最大値',
      },
    },
  },
  previewer: {
    title: 'リフレッシュ',
    loadingText: '読み込み中',
    selectText: '選択してください',
    selectLanguage: 'プレビュー言語の選択',
    selectDevice: 'プレビュー機器の選択',
    selectVersion: 'プレビューコンボの選択',
    scenes: {
      start: 'プレイテストセクション',
      ending: '終了セクション',
    },
    previewSuccess: 'プレビューリンクの生成に成功しました',
    qrcodeText: '携帯で確認',
  },
  saveSuccess: '保存成功',
  saveFail: '保存失敗',
  savingWarning: '素材作成中、他の操作は許可されません',
  saveButton: '保存',
  withoutTemplateId: 'URLにバージョンIDがありません',
  resourceNotSupport: 'この種類のリソースはサポートされていません',
  resourceDialog: {
    uploadRuleLabel: 'アップロードコンテンツの形式制限：',
    imageSize: '画像サイズ：',
    frameSequence: {
      label: 'シーケンスフレームのフォーマット要件：',
      picName: '画像の命名要件：',
      imageSize: '画像サイズおよびフレーム数',
    },
    dragonBones: {
      label: 'ドラゴンボーンのフォーマット要件：',
    },
    video: {
      format: 'Mp4のアップロードをサポート（ビデオから音声を削除する必要あり）',
    },
    model: {
      label: 'フォーマット：',
      format: 'ZIP形式（gltf/glb/(glb+bin) + jpg/pngを含む）',
      rules: 'モデルアップロード規約を確認する',
      rulesTip:
        'メッシュとボーンのスケールは単位を一致させる必要があります。<br />当社のテンプレートボーンを使用してスキニングとリギングを行ってください。<br />Bip001をスキニングに含める必要があります。',
    },
    resourceEdit: '素材編集',
    submitButton: '確認',
    cancleButton: 'キャンセル',
    uploadWarning: '同じリソース位置には同じリソースをアップロードできません',
    uploadingWarning:
      '素材のアップロード中にポップアップを閉じることは許可されません',
    fileUpload: {
      label: 'ファイルサイズ制限：',
      default: '最大1MB',
      frameSequence: '最大8MB',
      dragonBones: '最大1MB',
      video: '最大3MB',
      model: '最大5MB',
    },
    fileMetaData: {
      name: '名前',
      format: 'フォーマット',
      fileSize: 'ファイルサイズ',
      size: 'サイズ',
      imageSize: '画像サイズ',
      videoSize: '動画サイズ',
      duration: '音楽の長さ',
    },
    handlerRelated: {
      edit: '編集',
      delete: '削除',
      update: '置換',
      delWarningText1: '基本パッケージのコンテンツは削除できません',
      delWarningText2: 'デフォルトのコンテンツは削除できません',
      delWarningText3: 'オンライン素材の制作は削除できません',
      delTips: 'このリソースを削除しますか？',
      download: 'ダウンロード',
      operation: '操作',
    },
  },
  resourceUploader: {
    uploadButton: 'ローカルアップロード',
    uploadFail: 'アップロードに失敗しました、再試行してください',
    imgLoadFail: '画像の読み込みに失敗しました',
    warningText1: 'シーケンスフレームのサイズは3MBを超えてはいけません',
    warningText2: 'ドラゴンボーンのサイズは1MBを超えてはいけません',
    warningText3: '音声のサイズは1MBを超えてはいけません',
    warningText4: '画像のサイズは1MBを超えてはいけません',
    videoWarningText: 'ビデオのサイズは3MBを超えてはいけません',
    tagLabelTips:
      'タグはアルゴリズムの学習に役立ち、より精密で効率的なアセットの組み合わせを抽出するのに役立ちます',
    tagLabel: 'タグ',
    editLabel: '編集',
    tagPlaceholder: 'タグを選択してください',
    audioLabel: '音楽',
    audioUploadTitle: 'アップロード',
    cancel: 'キャンセル',
    submit: '確認',
    uploadingTips:
      'アップロードファイル中はポップアップを閉じることができません',
    assetNotExist: 'このアセットは削除されました、もう一度選択してください',
  },
  languageSelector: {
    error: {
      noDefaultLanguage: 'デフォルトの言語はありません',
    },
  },
  difficultySelect: {
    addText: '追加',
  },
  editResourceDialog: {
    title: {
      image: '画像',
      audio: '音',
      dragonBones: 'ドラゴンボーン',
      movieClip: 'シーケンスフレーム',
      model: '3Dモデル',
    },
  },
  resource: {
    noTagTips:
      'この要素はまだタグが付いていません、ダブルクリックして追加してください',
    globalNoTagTips: 'DCOリソースにはタグが必要です',
  },
  multiCustom: {
    addBtnTips: '組み合わせを追加',
    numTips: 'プレイ可能な広告の組み合わせ数：',
    multiCategory: '複数の組み合わせアセット',
  },
  qrcodeScan: {
    text: 'プレビュー',
  },
  editing: '素材は編集中です、後でもう一度お試しください',
  textEditButton: {
    applyToOtherLanguage: '他の言語に適用',
    applyToOtherLanguageTips: 'フォントとフォントサイズは含まれていません',
    applyToScreen: ['横画面に適用', '縦画面に適用'],
    languageAlert: '他の言語にに適用されました',
    ScreenAlert: ['横画面に適用', '縦画面に適用'],
  },
  screen: {
    title: '画面の適応',
    horizontal: '横向き',
    vertical: '縦向き',
    fovOffset: 'FOVオフセット',
    orthoHeightOffset: '正射投影高さオフセット',
  },
  scene: {
    title: 'カメラ',
    defaultScene: 'カメラ{idx}',
    polarAngle: '極角',
    azimuthAngle: '方位角',
    radialDistance: '半径距離',
    viewOffsetX: 'ビューオフセットX軸',
    viewOffsetY: 'ビューオフセットY軸',
    viewOffsetZ: 'ビューオフセットZ軸',
    dampingFactor: '減衰係数',
  },
  modelEdit: {
    title: 'モデル編集',
    updateBtn: 'モデルの置き換え',
    basic: {
      title: '基本パラメータ',
      translate: '位置',
      rotate: '回転角度',
      scale: '拡大縮小',
    },
    appearance: {
      title: '外観',
      partsOne: '部位1',
      partsTwo: '部位2',
      partsThree: '部位3',
      partsFour: '部位4',
      hub: '色相',
      saturation: '彩度',
      lightness: '明度',
      partsTitle: '部位改色',
      paramTitle: '材質パラメータ',
      mainColor: '主要な色 - オーバーレイ',
      occlusion: '環境遮蔽',
      roughness: '粗さ',
      metallic: '金属光沢',
      specularIntensity: '鏡面強度',
      emissive: '自己発光の色',
    },
    action: {
      title: 'アニメーション',
      action: 'アニメーション',
      speed: 'そくど',
      sharedActionTip:
        '他のモデルと共有されているため、変更はすべてのモデルに影響します：',
      keyFrame: 'キーフレームの調整',
      keyFrameSlide:
        '右側のプレビューエリアでダイヤモンドスライダーを調整します。',
      playSpecialEffects:
        'アニメーションがこのフレームに到達すると、エフェクトが再生されます。',
      changeNumber:
        'アニメーションがこのフレームに到達すると、ダメージや回復など数値の変化が生じます。',
    },
    viewer: {
      editBefore: '修正前',
      editAfter: '修正後',
    },
    cancelBtn: 'キャンセル',
    saveBtn: '保存',
    noResult: 'パラメータの調整はサポートされていません',
  },
}
